<formio [form]='{
    "title": "My Test Form",
    "components": [
        {
            "type": "textfield",
            "key": "coursetitle",
            "input": true,
            "label": "Course Title"
        },
        {
            "type": "textfield",
            "key": "courseaudio",
            "input": true,
            "label": "Audio url"
        },
        {
            "type": "textfield",
            "key": "courseaudiodesc",
            "input": true,
            "label": "Audio description"
        },
        {
            "type": "textfield",
            "key": "courseimage",
            "input": true,
            "label": "Image Url"
        },
        {
            "input": true,
            "label": "Submit",
            "tableView": false,
            "key": "submit",
            "size": "md",
            "leftIcon": "",
            "rightIcon": "",
            "block": false,
            "action": "submit",
            "disableOnInvalid": true,
            "theme": "primary",
            "type": "button"
        }
    ]
}' (submit)="onSubmit($event)"></formio>